import { render } from "./Success.vue?vue&type=template&id=6040d5ad&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import "./Success.vue?vue&type=style&index=0&id=6040d5ad&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6040d5ad"]])

export default __exports__